import { render, staticRenderFns } from "./InputFields.vue?vue&type=template&id=4a2f1879&scoped=true&"
import script from "./InputFields.vue?vue&type=script&lang=js&"
export * from "./InputFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2f1879",
  null
  
)

export default component.exports